import { Component, ViewChild, AfterViewInit, inject, ChangeDetectorRef } from '@angular/core';
import { columnModel } from '../../../components/table/model/columnModel';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { Router } from '@angular/router';
import { ListConfigurationService } from '../../../services/list-configuration.service';
import { SignatureService } from '../../../services/signature.service';
import { FilterSignature } from '../../../models/filters/filter-signature';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-signatures',
  standalone: false,
  templateUrl: './signatures.component.html',
  styleUrl: './signatures.component.css'
})
export class SignaturesComponent {
  @ViewChild(TableComponent) signaturesTable:TableComponent | undefined;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'N\u00FAmero',columnValue:'id'},
      {columnName:'Descripci\u00F3n Configuraci\u00F3n',columnValue:'description'},
      //{columnName:'Activo',columnValue:'active'},
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterSignature: FilterSignature = new FilterSignature;
  advancedSearch: boolean = false;

  private signatureService = inject(SignatureService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngAfterViewInit() {
    //Promise.resolve().then(() =>  this.divisionsTable.initTable());
  }

  ngOnInit(): void {
    this.searchSignaturePaginator();
  }

  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchSignaturePaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/signatures/edit', event.id]);
  }

  searchSignaturePaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchSignaturePaginator();
  }

  searchSignaturePaginator(){
    this.loading = true;

    this.signatureService.findAllPageableSignature(this.filterSignature, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.signaturesTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });
  }

  addNewSignaturesGroup(){
    this.router.navigate(['/signatures/edit', 0]);
  }

}
